import { useState } from "react";
import { useDispatch } from "react-redux";
import { checkAll, clearChecks, deleteDocument } from "../../../store/actions/admin/content-actions";
import { deleteColors, deleteFonts } from "../../../store/actions/admin/create-event";
import { deleteRecordedVideo, deleteUploadedVideo } from "../../../store/actions/admin/videos";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { FILE_TYPES } from "../../../store/utils/content-utils";
import ModalComponent from "../../general-ui/modal/modal";

interface EditingOptionsProps {
	checkedSetSize: number;
	fileType: number;
	idList: (number | string)[];
}

const EditingOptions: React.FC<EditingOptionsProps> = ({ checkedSetSize, fileType, idList }) => {

	const checkedSet = useTypedSelector(state => state.ContentReducer.checkedSet);
	const token = useTypedSelector(state => state.AuthReducer.token);
	const user = useTypedSelector(state => state.AuthReducer.user);

	const [isDeleting, setIsDeleting] = useState(false);
	const dispatch = useDispatch();

	const handleCancel = () => dispatch(clearChecks());
	const handleSelectAll = () => dispatch(checkAll(idList));
	const openDeleteModal = () => setIsDeleting(true);
	const closeDeleteModal = () => setIsDeleting(false);
	const handleDelete = () => {
		if (!token || !user) return;
		switch (fileType) {
			case FILE_TYPES.RECORDED:
				dispatch(deleteRecordedVideo(Array.from(checkedSet) as number[], token, user.active_channel));
				break;
			case FILE_TYPES.UPLOADED:
				dispatch(deleteUploadedVideo(Array.from(checkedSet) as number[], token, user.active_channel));
				break;
			case FILE_TYPES.FONTS:
				dispatch(deleteFonts(Array.from(checkedSet) as number[], token, user.active_channel));
				break;
			case FILE_TYPES.PALETTES:
				dispatch(deleteColors(Array.from(checkedSet) as number[], token, user.active_channel));
				break;
			default: //Documents and Images
				dispatch(deleteDocument(Array.from(checkedSet) as number[], token, user.active_channel));
		}
		handleCancel(); // clear all selected items
		closeDeleteModal();
	};

	const getDeleteWarning = () => {
		let file;
		switch (fileType) {
			case (FILE_TYPES.UPLOADED):
			case (FILE_TYPES.RECORDED):
				file = "video";
				break;
			case (FILE_TYPES.FONTS):
				file = "font";
				break;
			case (FILE_TYPES.IMAGES):
				file = "image";
				break;
			case (FILE_TYPES.PALETTES):
				file = "color palette";
				break;
			default:
				file = "document";
		}
		return `Are you sure you want to delete ${checkedSetSize === 1 ? "this" : "these"} ${file}${checkedSetSize > 1 ? "s" : ""}?`;
	};

	return (
		<div className="content-editing-options">
			<button className="editing-button" onClick={handleCancel}>Cancel</button>
			<button className="editing-button" onClick={handleSelectAll}>Select All</button>
			<button className="editing-button" onClick={openDeleteModal}>Delete</button>
			<ModalComponent
				title=""
				open={isDeleting}
				onRequestClose={closeDeleteModal}
				closeable={false}
				cancellable
				footer={
					<div className="delete-modal-buttons">
						<button onClick={closeDeleteModal}>Cancel</button>
						<button onClick={handleDelete} className="primary">Delete</button>
					</div>
				}
			>
				<p>{getDeleteWarning()}</p>
			</ModalComponent>
		</div>
	);
};

export default EditingOptions;